import { SelectItem } from '@/_components/Select/Select.types';
export const sectionTypes = [
  {
    id: 0,
    key: 'custom',
    label: 'Custom',
    defaultInstruction: 'Please complete the following.',
  },
  {
    id: 2,
    key: 'agreement_signature',
    label: 'Agreement Signature Request',
    defaultInstruction: 'Please e-sign the letter with your full name.',
  },
  {
    id: 3,
    key: 'questionnaire',
    label: 'Questionnaire',
    defaultInstruction: 'Please complete all items.',
  },
  {
    id: 4,
    key: 'review_and_submit',
    label: 'Review & Submit',
    defaultInstruction:
      'Please review your answers for all sections and submit your answers.',
  },
  {
    id: 6,
    key: 'pdf_review',
    label: 'PDF Review Request',
    defaultInstruction:
      'Please read the document and mark that you have thoroughly read it.',
    hidden: true,
  },
  {
    id: 7,
    key: 'payment_request',
    label: 'Payment Request',
    defaultInstruction: 'Please use the link below to pay the fee.',
    hidden: true,
  },
  {
    id: 8,
    key: 'download_document',
    label: 'Download Document',
    defaultInstruction: 'Please download the file below.',
    hidden: true,
  },
  {
    id: 9,
    key: 'pdf_signature',
    label: 'PDF Signature Request',
    defaultInstruction: 'Please sign on the signature box below.',
    hidden: true,
  },
  {
    id: 10,
    key: 'document_checklist',
    label: 'Document Checklist',
    defaultInstruction: 'Use this section to upload the requested documents.',
  },
  {
    id: 11,
    key: 'delivery',
    label: 'Tax Return Delivery',
    locked: true,
    defaultInstruction: 'Please sign form 8879 and download your tax return.',
  },
];
export const ADDITIONAL_SECTION: SelectItem = {
  name: 'Additional Items',
  value: '',
};
